module.exports = __webpack_public_path__ + "static/media/Gabe Zentall.96be84fd.png";